import React, { Component } from 'react'
import cx from 'classnames'
import { connect } from 'react-redux'
import * as GateSelectors from 'app/modules/gates/selectors'
import * as style from './style'

class OnlineIndicator extends Component {
  render() {
    const { className, hasPresence } = this.props

    if (!hasPresence) {
      return null
    }

    return <div className={cx(style.onlineIndicator, className)} />
  }
}

const makeMapStateToProps = function() {
  return function(state) {
    return {
      hasPresence: GateSelectors.hasPresence(state)
    }
  }
}

export default connect(makeMapStateToProps)(OnlineIndicator)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/Profile/EndUserAvatar/OnlineIndicator/index.js